import RuTexts from './ru'
import EnTexts from './en'
export const messages = {
  ru: RuTexts,
  en: EnTexts,
}
